export default __webpack_public_path__ + "static/media/phone.c1b365be.svg";